(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reg-furniture-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('reg-furniture-finder')) {
  customElements.define('reg-furniture-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const select = this.querySelector('[data-finder-category]');
      if (!select) return;
      const forms = Array.from(this.querySelectorAll('[data-finder-form]'));
      const update = () => forms.forEach(form => { form.hidden = form.dataset.finderForm !== select.value; });
      select.addEventListener('change', update);
      this.querySelector('[data-finder-switch]').hidden = false;
      this.addEventListener('submit', event => {
        event.target.querySelectorAll('input[name],select[name]').forEach(field => { field.disabled = field.value === ''; });
        setTimeout(() => event.target.querySelectorAll('[disabled]').forEach(field => { field.disabled = false; }), 0);
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
